import __ from "standard/dunder";
import globalAttributes from "standard/globalAttributes";

class Input extends HTMLElement {
  get name() {
    return this.shadowRoot.querySelector("input")?.name ?? "";
  }

  get type() {
    return __.control__;
  }

  get validity() {
    return this.shadowRoot.querySelector("input")?.validity;
  }

  get value() {
    return this.shadowRoot.querySelector("input")?.value ?? "";
  }

  static get observedAttributes() {
    return globalAttributes;
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    this.addEventListener("invalid", this[__.onInvalid__]?.bind(this));
    return this;
  }

  disconnectedCallback() {
    this.removeEventListener("invalid", this[__.onInvalid__]?.bind(this));
    return this;
  }
}

export default Input;
